import { render, staticRenderFns } from "./TodasOcorrencias.vue?vue&type=template&id=241cf20a&scoped=true"
import script from "./TodasOcorrencias.vue?vue&type=script&lang=js"
export * from "./TodasOcorrencias.vue?vue&type=script&lang=js"
import style0 from "./TodasOcorrencias.vue?vue&type=style&index=0&id=241cf20a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241cf20a",
  null
  
)

export default component.exports